import React, { useMemo, useState } from 'react';

import StockDetail from "Components/StockDetail";
import DialogPortal from "Components/DialogPortal";



const IssueStock = ({ data, rank }) => {
  const { stock_code, nm, cv, cr, rf, nv } = data;
  const [showDetail, setOpenDetail] = useState(false);

  const updownClass = useMemo(()=>{
    if (cv === 0) {
      return '';
    }
    if ([4, 5].includes(rf)) {
      return 'down';
    }
    return 'up';
  },[rf, cv])


  return (
    <li data-code={stock_code} data-no={rank} onClick={setOpenDetail.bind(null, true)} style={{ cursor: 'pointer' }} >
      <p className="corp">{nm}</p>
      <p className={`now ${updownClass}`}>{nv.toLocaleString('ko-KR')}</p>
      <div className={`status ${updownClass}`}>{`${cv.toLocaleString('ko-KR')} (${cr}%)`}</div>
      {
        showDetail ?
        <DialogPortal>
          <StockDetail stockDetail={data} callback={setOpenDetail.bind(null, false)} />
        </DialogPortal> : null
      }
    </li>
  )
}


export default IssueStock;